export const urlRegex = /^(https?:\/\/)([\w.-]+)(\.[a-z]{2,})(\/[\w.-]+)*\/?$/
